<template>
  <b-modal :id="modalId" size="md" no-close-on-backdrop no-close-on-esc no-fade no-stacking centered>
    <template #modal-header>
      <div class="my-auto">
        <h2 class="font-weight-normal" data-test-hook="mobile-subscription-modal-header">
          <div>
            <i class="far fa-warning colorOrange mr-1" data-test-hook="mobile-subscription-modal-header-icon" />
            {{ $t('xYourAccountNeedsAttentionHeader') }}
          </div>
        </h2>
      </div>
      <div class="float-right">
        <b-button
          class="btn-icon-button--gray"
          variant="icon-button"
          @click="$bvModal.hide(modalId)"
          data-test-hook="x-button-feedback-modal"
        >
          <i class="fas fa-times" />
        </b-button>
      </div>
    </template>
    <div>
      <p v-if="requireUpgrade && isHsb">
        {{ productNotIncludedText }}
        <a href="https://www.generac.com/dealer-locator/" target="_blank">
          {{ $t('xThisProductNotIncludedFindDealer') }}
        </a>
      </p>
      <p v-else-if="requireUpgrade && isFuelMonitor">
        {{ productNotIncludedText }}
      </p>
      <p v-else>
        {{ productNotIncludedText }}
      </p>
      <p>{{ storeManageText }}</p>
    </div>
    <template #modal-footer>
      <b-button
        variant="secondary"
        @click="$bvModal.hide(modalId), $emit('removePressed')"
        :disabled="billingMaintenanceFeatureFlagEnabled(currentAppConfig)"
      >
        {{ $t('xRemoveFromAccount') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'

export default {
  props: [
    'modalId',
    /** Mobile store the subscription was purchased from. Either Constants.AppleSubscriptionStore or Constants.GoogleSubscriptionStore. */
    'store',
    /** Either Constants.HsbApparatusType or Constants.FuelTankApparatusType. */
    'apparatusType',
    'requireUpgrade'
  ],
  emits: ['removePressed'],
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    }),
    storeManageText() {
      if (this.requireUpgrade) {
        if (this.store === Constants.AppleSubscriptionStore) {
          return this.$t('xUpgradePlanOnApple')
        } else if (this.store === Constants.GoogleSubscriptionStore) {
          return this.$t('xUpgradePlanOnGoogle')
        }
      } else {
        if (this.store === Constants.AppleSubscriptionStore) {
          return this.$t('xUpdatePlanOnApple')
        } else if (this.store === Constants.GoogleSubscriptionStore) {
          return this.$t('xUpdatePlanOnGoogle')
        }
      }
      return ''
    },
    productNotIncludedText() {
      if (this.requireUpgrade) {
        if (this.isHsb) {
          return this.$t('xThisGeneratorNotIncludedInAPlan')
        }
        if (this.isFuelMonitor) {
          return this.$t('xThisFuelMonitorNotIncludedInAPlan')
        }
      } else {
        if (this.isHsb) {
          return this.$t('xThisGeneratorNotIncludedInAPlanUpdate')
        }
        if (this.isFuelMonitor) {
          return this.$t('xThisFuelMonitorNotIncludedInAPlanUpdate')
        }
      }
      return ''
    },
    isHsb() {
      return this.apparatusType === Constants.HsbApparatusType
    },
    isFuelMonitor() {
      return this.apparatusType === Constants.FuelTankApparatusType
    }
  }
}
</script>
